import { render } from "./StockTransferReport.vue?vue&type=template&id=760bd8df&scoped=true"
import script from "./StockTransferReport.vue?vue&type=script&lang=js"
export * from "./StockTransferReport.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=760bd8df&scoped=true&lang=css&external"
import "./StockTransferReport.vue?vue&type=style&index=1&id=760bd8df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760bd8df"]])

export default __exports__